const TermsPage = () => {
  return (
    <div className="min-h-screen pt-24 md:pt-32 bg-[#FAFAFA]" data-testid="terms-page">
      <div className="container-elegant py-8 md:py-16">
        <div className="max-w-3xl mx-auto">
          <p className="text-malva-dark font-sans text-sm tracking-[0.3em] uppercase mb-4">
            Legal
          </p>
          <h1 className="font-serif text-4xl md:text-5xl text-gray-800 mb-8">
            Terms & Conditions
          </h1>
          
          <div className="prose prose-lg max-w-none space-y-8">
            <p className="text-gray-500">
              Last updated: December 2024
            </p>

            <section className="card-elegant p-6">
              <h2 className="font-serif text-2xl text-gray-800 mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-600 leading-relaxed">
                By accessing and using the Reva Dining website and services, you accept and agree 
                to be bound by the terms and provision of this agreement. If you do not agree to abide 
                by these terms, please do not use this service.
              </p>
            </section>

            <section className="card-elegant p-6">
              <h2 className="font-serif text-2xl text-gray-800 mb-4">2. Reservations Policy</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                All reservations are subject to availability. We kindly request guests to:
              </p>
              <ul className="text-gray-600 list-disc list-inside space-y-2">
                <li>Arrive within 15 minutes of the reserved time</li>
                <li>Cancel at least 24 hours in advance</li>
                <li>Notify us of any special dietary requirements or celebrations</li>
                <li>Inform us of the complete party size when booking</li>
              </ul>
            </section>

            <section className="card-elegant p-6">
              <h2 className="font-serif text-2xl text-gray-800 mb-4">3. Online Orders</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                When placing an order through our website:
              </p>
              <ul className="text-gray-600 list-disc list-inside space-y-2">
                <li>All prices are in GBP and inclusive of applicable taxes</li>
                <li>Orders are subject to acceptance and availability</li>
                <li>Delivery times are estimates and may vary</li>
                <li>We reserve the right to refuse service to anyone</li>
              </ul>
            </section>

            <section className="card-elegant p-6">
              <h2 className="font-serif text-2xl text-gray-800 mb-4">4. Payment Terms</h2>
              <p className="text-gray-600 leading-relaxed">
                We accept major credit cards processed through Stripe. All transactions are secure and 
                encrypted. Prices are subject to change without notice. Refunds for online orders will 
                be processed within 5-7 business days.
              </p>
            </section>

            <section className="card-elegant p-6">
              <h2 className="font-serif text-2xl text-gray-800 mb-4">5. Contact</h2>
              <p className="text-gray-600 leading-relaxed">
                For questions about these terms, please contact us at{' '}
                <a href="mailto:bookings@revadining.co.uk" className="text-malva-dark hover:text-malva-darker transition-colors">
                  bookings@revadining.co.uk
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
